// src/components/ourFavorites.jsx
import { useRef } from "react";
import { Link } from "react-router-dom";
import "../index.css";

const DISHES = [
    { id: "l1", title: "Mongolian Beef - B4", text: "Beef and onions tossed in a sweet a spicy sauce, all served on a bed of crispy rice noodles .", img: "/MongoBeef2.jpeg" },
    { id: "l2", title: "House Hofun", text: "Soft rice noodles with a chew, wok-tossed with meat and veggies. A Cantonese favorite.", img: "/hofun.webp" },
    { id: "l3", title: "Honey Walnut Prawns - Q4", text: "Crispy prawns and candied walnuts tossed in a sweet mayo sauce.", img: "/Q4.webp" },
    { id: "l4", title: "House Chow Mein", text: "Chicken, beef, pork, and and noodles stir fried to perfection.", img: "/dish2.jpeg" },
    { id: "l5", title: "Sesame Chicken - Q8", text: "Lightly breaded chicken tossed in our sweet and addictive sesame sauce.", img: "/Q8.jpg" },
    // { id: "l6", title: "General Tso’s Chicken - Q5", text: "Crunchy chicken glazed in tangy heat. A staple in Chinese American restaurants", img: "/" },
    // { id: "l7", title: "Sizzling Platter - Q1", text: "Beef, chicken, pork, and veggies stir fried on a hot pan. It's sure to attract everyones attention", img: "" },
    ];

export default function OurFavorites() {
  const viewportRef = useRef(null);

  const getCardWidth = () => {
    const vp = viewportRef.current;
    if (!vp) return 0;
    const firstCard = vp.querySelector(".fav-card");
    if (!firstCard) return 0;
    // const styles = getComputedStyle(firstCard);
    const w = firstCard.getBoundingClientRect().width;
    const gap = parseFloat(getComputedStyle(vp).gap || "0");
    return w + gap;
  };

  const scrollOne = (dir = 1) => {
    const vp = viewportRef.current;
    if (!vp) return;
    const step = getCardWidth();
    if (!step) return;

    const atEnd = Math.ceil(vp.scrollLeft + vp.clientWidth) >= vp.scrollWidth;
    const atStart = vp.scrollLeft <= 0;

    if (dir > 0 && atEnd) {
      // wrap to start
      vp.scrollTo({ left: 0, behavior: "smooth" });
    } else if (dir < 0 && atStart) {
      // wrap to end
      vp.scrollTo({ left: vp.scrollWidth, behavior: "smooth" });
    } else {
      vp.scrollBy({ left: dir * step, behavior: "smooth" });
    }
  };

  return (
    <section className="favorites-section">
      <div className="favorites-inner">
        <h2 className="section-title">Our Favorites</h2>

        <div className="favorites-shell">
          <button
            className="favorites-arrow left"
            aria-label="Previous"
            onClick={() => scrollOne(-1)}
          >
            ‹
          </button>

          <div className="favorites-viewport" ref={viewportRef} aria-live="polite">
            {DISHES.map((it) => (
              <article key={it.id} className="fav-card">
                <div
                  className="fav-card-media"
                  role="img"
                  aria-label={it.title}
                  style={{ backgroundImage: `url(${it.img})`, backgroundSize: "cover", backgroundPosition: "center" }}
                />
                <div className="fav-card-body">
                  <h3 className="fav-card-title">{it.title}</h3>
                  <p className="fav-card-text">{it.text}</p>
                  <Link to="/menu" className="btn btn-primary">Full Menu</Link>
                </div>
              </article>
            ))}
          </div>

          <button
            className="favorites-arrow right"
            aria-label="Next"
            onClick={() => scrollOne(1)}
          >
            ›
          </button>
        </div>
      </div>
    </section>
  );
}
